import * as React from 'react';
import { LoadOptions } from 'ui';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { ButtonComponentProps } from 'app/area/codetable/list/list-renderer/types';
import { CodeSinglePicker } from 'app/area/codetable/common';
import { CodetableTranslation } from 'app/area/codetable/constants';

import styles from './add-code-modal.scss';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { ModalSize } from 'app/components/constants';

import type { JSX } from "react";

export interface AddCodeModalProps {
  id: string;
  buttonText: string;
  labelText: string;
  dropdownLabelText: string;
  submitText: string;
  submit: (id: number) => void;

  pickerId: string;
  codes: CodeComplexValue<number>[];
  fetching: boolean;
  loadOptions: (id: string, loadOptionsParams: LoadOptions) => void;

  actionText?: string;
  onAction?: () => void;

  ButtonComponent: ButtonComponentProps;

  translation: CodetableTranslation;
}

export interface AddCodeModalState {
  showModal: boolean;
  value: CodeComplexValue<number>;
}

export class AddCodeModal extends React.Component<AddCodeModalProps, AddCodeModalState> {
  public state: Readonly<AddCodeModalState> = { showModal: false, value: undefined };

  private onChange = (value: CodeComplexValue<number>) => this.setState({ value });

  private showAddCodeModal = () => this.setState({ showModal: true });
  private hideAddCodeModal = () => this.setState({ value: undefined, showModal: false });

  private onDone = () => {
    this.props.submit(this.state.value.value);
    this.hideAddCodeModal();
  };

  public render(): JSX.Element {
    const {
      buttonText, actionText, labelText, submitText, dropdownLabelText, ButtonComponent, translation,
      pickerId, codes, fetching, loadOptions, onAction } = this.props;

    return <>
      <ButtonComponent onClick={this.showAddCodeModal}>
        {buttonText}
      </ButtonComponent>

      {this.state.showModal && <ModalWrapper
        headerTitle={labelText}
        btnTitle={submitText}
        btnActionTitle={actionText}
        btnCancelTitle={translation.cancel}
        onClose={this.hideAddCodeModal}
        onAction={onAction}
        onDone={this.onDone}
        isDisabled={!this.state.value}
        isActionDisabled={false}
        canCloseOnBackground={true}
        size={ModalSize.large}>
        <div className={styles.wrapper}>
          <CodeSinglePicker
            id={pickerId}
            className={styles.picker}
            label={dropdownLabelText}
            valueItem={this.state.value}
            options={codes}
            fetchingOptions={fetching}
            translation={translation}
            onLoadOptions={loadOptions}
            onChange={this.onChange}
          />
        </div>
      </ModalWrapper>}
    </>;
  }
}
